import { Fragment } from 'react';
import { usewpdataSelectors } from '../../lib/wpdataState/selectors';
import s from './styles/benefits.module.scss';

const Benefits = ({ variant }: { variant: string | null }) => {
  const { hero } = usewpdataSelectors();

  interface Benefit {
    feature_image: string;
    tr_feature_title: string;
    tr_feature_description: string;
  }

  return (
    <div className={`${s.benefits} ${variant === 'productHero' ? s['benefits__productHero'] : ''}`}>
      {hero?.benefits &&
        hero.benefits.map((benefit: Benefit, index: number) => (
          <Fragment key={`benefit-${index}-${benefit.feature_image}`}>
            <div className={`${s.benefits__item}`}>
              <img src={benefit.feature_image} alt={benefit.tr_feature_title} />
              <div className={s.benefits__titles}>
                <div className={s.benefits__titles__main} style={{ color: hero.styles.featureTitleColor }}>
                  {benefit.tr_feature_title}
                </div>
                <div className={s.benefits__titles__sub} style={{ color: hero.styles.textColorSecondary }}>
                  {benefit.tr_feature_description}
                </div>
              </div>
            </div>
          </Fragment>
        ))}
    </div>
  );
};

export default Benefits;
